export const PERIOD_ADMIN_SAVE_INIT = 'PERIOD_ADMIN_SAVE_INIT';
export const PERIOD_ADMIN_SAVE_SUCCESS = 'PERIOD_ADMIN_SAVE_SUCCESS';
export const PERIOD_ADMIN_SAVE_FAILURE = 'PERIOD_ADMIN_SAVE_FAILURE';
export const PERIOD_ADMIN_SET_SAVE_DATA_BY_KEY = 'PERIOD_ADMIN_SET_SAVE_DATA_BY_KEY';
export const PERIOD_ADMIN_SAVE_RESET = 'PERIOD_ADMIN_SAVE_RESET';

export const PERIOD_ADMIN_GET_PERIODS_LIST_INIT = 'PERIOD_ADMIN_GET_PERIODS_LIST_INIT';
export const PERIOD_ADMIN_GET_PERIODS_LIST_SUCCESS = 'PERIOD_ADMIN_GET_PERIODS_LIST_SUCCESS';
export const PERIOD_ADMIN_GET_PERIODS_LIST_FAILURE = 'PERIOD_ADMIN_GET_PERIODS_LIST_FAILURE';

export const PERIOD_ADMIN_SET_ACTIVE_PERIOD = 'PERIOD_ADMIN_SET_ACTIVE_PERIOD';

export const PERIOD_ADMIN_CHANGE_PERIOD_STATE_INIT = 'PERIOD_ADMIN_CHANGE_PERIOD_STATE_INIT';
export const PERIOD_ADMIN_CHANGE_PERIOD_STATE_SUCCESS = 'PERIOD_ADMIN_CHANGE_PERIOD_STATE_SUCCESS';
export const PERIOD_ADMIN_CHANGE_PERIOD_STATE_FAILURE = 'PERIOD_ADMIN_CHANGE_PERIOD_STATE_FAILURE';

export const PERIOD_ADMIN_CLOSE_PERIOD_INIT = 'PERIOD_ADMIN_CLOSE_PERIOD_INIT';
export const PERIOD_ADMIN_CLOSE_PERIOD_SUCCESS = 'PERIOD_ADMIN_CLOSE_PERIOD_SUCCESS';
export const PERIOD_ADMIN_CLOSE_PERIOD_FAILURE = 'PERIOD_ADMIN_CLOSE_PERIOD_FAILURE';

export const PERIOD_ADMIN_GET_GROUPS_INIT = 'PERIOD_ADMIN_GET_GROUPS_INIT';
export const PERIOD_ADMIN_GET_GROUPS_SUCCESS = 'PERIOD_ADMIN_GET_GROUPS_SUCCESS';
export const PERIOD_ADMIN_GET_GROUPS_FAILURE = 'PERIOD_ADMIN_GET_GROUPS_FAILURE';

export const PERIOD_ADMIN_GET_CALCULATION_UNITS_INIT = 'PERIOD_ADMIN_GET_CALCULATION_UNITS_INIT';
export const PERIOD_ADMIN_GET_CALCULATION_UNITS_SUCCESS = 'PERIOD_ADMIN_GET_CALCULATION_UNITS_SUCCESS';
export const PERIOD_ADMIN_GET_CALCULATION_UNITS_FAILURE = 'PERIOD_ADMIN_GET_CALCULATION_UNITS_FAILURE';

export const PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT = 'PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT';
export const PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS = 'PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS';
export const PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE = 'PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE';

export const PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_INIT = 'PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_INIT';
export const PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS = 'PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS';
export const PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE = 'PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE';

export const PERIOD_ADMIN_IMPORT_INIT = 'PERIOD_ADMIN_IMPORT_INIT';
export const PERIOD_ADMIN_IMPORT_SUCCESS = 'PERIOD_ADMIN_IMPORT_SUCCESS';
export const PERIOD_ADMIN_IMPORT_FAILURE = 'PERIOD_ADMIN_IMPORT_FAILURE';
export const PERIOD_ADMIN_IMPORT_RESET = 'PERIOD_ADMIN_IMPORT_RESET';

export const PERIOD_ADMIN_GET_IMPORT_FILES_LIST_INIT = 'PERIOD_ADMIN_GET_IMPORT_FILES_LIST_INIT';
export const PERIOD_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS = 'PERIOD_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS';
export const PERIOD_ADMIN_GET_IMPORT_FILES_LIST_FAILURE = 'PERIOD_ADMIN_GET_IMPORT_FILES_LIST_FAILURE';

export const PERIOD_ADMIN_CALCULATE_INIT = 'PERIOD_ADMIN_CALCULATE_INIT';
export const PERIOD_ADMIN_CALCULATE_SUCCESS = 'PERIOD_ADMIN_CALCULATE_SUCCESS';
export const PERIOD_ADMIN_CALCULATE_FAILURE = 'PERIOD_ADMIN_CALCULATE_FAILURE';

export const PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_INIT = 'PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_INIT';
export const PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS = 'PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS';
export const PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE = 'PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE';

export const PERIOD_ADMIN_DELETE_CALCULATION_PREPARE_INIT = 'PERIOD_ADMIN_DELETE_CALCULATION_PREPARE_INIT';
export const PERIOD_ADMIN_DELETE_CALCULATION_INIT = 'PERIOD_ADMIN_DELETE_CALCULATION_INIT';
export const PERIOD_ADMIN_DELETE_CALCULATION_SUCCESS = 'PERIOD_ADMIN_DELETE_CALCULATION_SUCCESS';
export const PERIOD_ADMIN_DELETE_CALCULATION_FAILURE = 'PERIOD_ADMIN_DELETE_CALCULATION_FAILURE';

export const PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT = 'PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT';
export const PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS = 'PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS';
export const PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE = 'PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE';

export const PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT = 'PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT';
export const PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS = 'PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS';
export const PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE = 'PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE';

export const PERIOD_ADMIN_GET_POLYNOMIALS_LIST_INIT = 'PERIOD_ADMIN_GET_POLYNOMIALS_LIST_INIT';
export const PERIOD_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS = 'PERIOD_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS';
export const PERIOD_ADMIN_GET_POLYNOMIALS_LIST_FAILURE = 'PERIOD_ADMIN_GET_POLYNOMIALS_LIST_FAILURE';

export const PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_INIT = 'PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_INIT';
export const PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_SUCCESS = 'PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_SUCCESS';
export const PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_FAILURE = 'PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_FAILURE';

export const PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_INIT = 'PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_INIT';
export const PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_SUCCESS = 'PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_SUCCESS';
export const PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_FAILURE = 'PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_FAILURE';

export const PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT = 'PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT';
export const PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS = 'PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS';
export const PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE = 'PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE';

export const PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_INIT = 'PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_INIT';
export const PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS = 'PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS';
export const PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE = 'PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE';

export const PERIOD_ADMIN_EXPORT_BI_REPORTS_INIT = 'PERIOD_ADMIN_EXPORT_BI_REPORTS_INIT';
export const PERIOD_ADMIN_EXPORT_BI_REPORTS_SUCCESS = 'PERIOD_ADMIN_EXPORT_BI_REPORTS_SUCCESS';
export const PERIOD_ADMIN_EXPORT_BI_REPORTS_FAILURE = 'PERIOD_ADMIN_EXPORT_BI_REPORTS_FAILURE';

export const PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_INIT = 'PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_INIT';
export const PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_SUCCESS = 'PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_SUCCESS';
export const PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_FAILURE = 'PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_FAILURE';

export const PERIOD_ADMIN_SOFT_RESET = 'PERIOD_ADMIN_SOFT_RESET';
export const PERIOD_ADMIN_RESET = 'PERIOD_ADMIN_RESET';

export const PERIOD_ADMIN_GET_CUSTOMER_INIT = 'PERIOD_ADMIN_GET_CUSTOMER_INIT';
export const PERIOD_ADMIN_GET_CUSTOMER_SUCCESS = 'PERIOD_ADMIN_GET_CUSTOMER_SUCCESS';
export const PERIOD_ADMIN_GET_CUSTOMER_FAILURE = 'PERIOD_ADMIN_GET_CUSTOMER_FAILURE';

export const PERIOD_ADMIN_ROLL_BACK_PERIOD_INIT = 'PERIOD_ADMIN_ROLL_BACK_PERIOD_INIT';
export const PERIOD_ADMIN_ROLL_BACK_PERIOD_SUCCESS = 'PERIOD_ADMIN_ROLL_BACK_PERIOD_SUCCESS';
export const PERIOD_ADMIN_ROLL_BACK_PERIOD_FAILURE = 'PERIOD_ADMIN_ROLL_BACK_PERIOD_FAILURE';

export const PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_INIT = 'PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_INIT';
export const PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_SUCCESS = 'PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_SUCCESS';
export const PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_FAILURE = 'PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_FAILURE';


// WEBPACK FOOTER //
// ./source/client/actions/periodAdmin/types.js